import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../state/store';
import { 
  setProductCategoryColor, 
  getProductCategoryColor as getProductCategoryColorAction,
  setColorTone,
  getTextColorForBackground
} from '../state/categoryColors/categoryColorsSlice';

export const useCategoryColors = () => {
  const dispatch = useDispatch();
  const { productCategoryColor, colorTone } = useSelector((state: RootState) => state.categoryColors);

  const setProductCategoryColorAction = (categoryName: string, color?: string) => {
    dispatch(setProductCategoryColor({ categoryName, color }));
  };

  const getProductCategoryColor = (categoryName: string): string => {
    if (productCategoryColor[categoryName]) {
      return productCategoryColor[categoryName];
    } else {
      // If color doesn't exist, set it and return the new color
      const newColor = getRandomColorFromTone(colorTone);
      dispatch(setProductCategoryColor({ categoryName, color: newColor }));
      return newColor;
    }
  };

  const setColorToneAction = (tone: number) => {
    dispatch(setColorTone(tone));
  };

  const getTextColor = (backgroundColor: string): string => {
    return getTextColorForBackground(backgroundColor);
  };

  return {
    productCategoryColor,
    colorTone,
    setProductCategoryColor: setProductCategoryColorAction,
    getProductCategoryColor,
    setColorTone: setColorToneAction,
    getTextColor
  };
};

// Helper function to get a random color from the selected tone
const getRandomColorFromTone = (tone: number): string => {
  const colorPalettes = [
    'primary',
    'neutral', 
    'success',
    'warning',
    'danger',
    'info',
    'general',
    'custom-app',
    'other',
    'finance',
    'recruitment',
    'marketing',
    'sales',
    'time-planning'
  ];
  
  const randomPalette = colorPalettes[Math.floor(Math.random() * colorPalettes.length)];
  return `var(--${randomPalette}-${tone})`;
}; 